import { render, staticRenderFns } from "./AssignLicencesDialog.vue?vue&type=template&id=14010a3e"
import script from "./AssignLicencesDialog.vue?vue&type=script&lang=js"
export * from "./AssignLicencesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports